<template>
<div>
    <Breadcrumbs main="Admin" submain="Submission" title="Student Submission" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="!loading && !error">
                            <h5>Student Info</h5>
                            <div style="display: flex; flex-direction: column; gap: 12px; margin-top: 12px;">
                                <h7><strong>Name:</strong> {{ submission.first_name }} {{ submission.last_name }}</h7>
                                <h7><strong>Email:</strong> {{ submission.email }}</h7>
                                <h7><strong>Phone:</strong> {{ submission.phone }}</h7>
                                <div style="display: flex; flex-direction: column; gap: 6px;">
                                    <strong>Image:</strong>
                                    <img style="height: 120px; width: fit-content; border-radius: 8px;" :src="host + submission.image" :alt="submission.first_name + ' ' + submission.last_name">
                                    <div style="display: flex; gap: 4px; margin-top: 6px;" v-if="submission.image">
                                        <h7>Link:</h7> <a :href="host + submission.image" target="_blank">{{ host + submission.image }}</a>
                                    </div>
                                </div>
                            </div>

                            <h5 class="mt-5">Content</h5>
                            <div style="display: flex; flex-direction: column; gap: 12px; margin-top: 12px;">
                                <h7><strong>Title:</strong> {{ submission.title }}</h7>
                                <h7><strong>Location:</strong> {{ submission.location?.name }}</h7>
                                <div style="display: flex; flex-direction: column; gap: 6px;">
                                    <strong>Banner:</strong>
                                    <img style="height: 120px; width: fit-content; border-radius: 8px;" :src="host + submission.banner" :alt="submission.title">
                                    <div style="display: flex; gap: 4px; margin-top: 6px;" v-if="submission.banner">
                                        <h7>Link:</h7> <a :href="host + submission.banner" target="_blank">{{ host + submission.banner }}</a>
                                    </div>
                                </div>
                                 <div style="display: flex; flex-direction: column; gap: 6px; margin-top: 6px;">
                                    <strong>Description:</strong>
                                    <div v-html="submission.description"></div>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host
        };
    },

    computed: {
        ...mapState({
            submission: state => state.words.submission_details,
            loading: state => state.words.submissionLoading,
            error: state => state.words.submissionError
        })
    },

    mounted() {
        this.$store.dispatch("words/fetchSubmissionDetails", this.$route.params.id);
    },

    watch: {
        '$route.params.id'(newId) {
            this.$store.dispatch("words/fetchSubmissionDetails", newId);
        }
    }
};
</script>
